$(document).ready(function(){
 $(".abo-wrapper #filchecknew").change(function(){
      if(this.checked) {
        $(".abo-wrapper #filldata").show();
        $(".btn.add-to-cart").addClass("abo-cart");
      }
      else{
        //console.log("else");
        $(".abo-wrapper #filldata").hide();
        $(".btn.add-to-cart").removeClass("abo-cart");
            $(".err").hide();
      $(".default-msg-check").hide();
        $("#filldata").val('');
        $(".abo-wrapper .default-msg-check #filcheck").attr("value"," ");
      }
    }) 
  $(".abo-wrapper .default-msg-check #filcheck").change(function(){
    if(this.checked) {
      $(this).attr("value","Ja, ohne persönliche Nachricht senden");
      $("#filldata").val('');
    }
    else{
      $(this).attr("value"," ");
    }
  })
  $('body').on('click', '.abo-cart', function(e) {
  e.preventDefault();
    if($('.abo-wrapper #filchecknew').is(':checked') &&  ($.trim($('#filldata').val()).length < 1)){
      //console.log("test");
      $(".err").show();
      $(".default-msg-check").show();
      if($('.abo-wrapper .default-msg-check #filcheck').is(':checked'))
      {
        $("#filldata").val('');
        $(".product-single__form").submit();
      }
      else{
      }
    }
    else{
            $(".err").hide();
      $(".default-msg-check").hide();
      $(".product-single__form").submit();
    }
  })                  
                  
    $('.template-collection .collection-banner-carousel').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite:true,
    arrows: true,
    dots: false,
    
  });
    $('.breadcrumb_productpage').appendTo('#MainContent');
   $( "#CartPageForm .cart__item.hide-popup" ).each(function() {
    if($(this).find('.cart__meta-text.property').text().indexOf('gift card') > -1){
      $('.shipping-popup').removeClass('hide');
    }
  });
    });